import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, withKeys as _withKeys, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, resolveDirective as _resolveDirective, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "d-flex justify-content-between align-items-center mb-6" }
const _hoisted_2 = { class: "card-title" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("i", { class: "bi bi-search" }, null, -1)
const _hoisted_4 = { class: "card-toolbar" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("i", { class: "bi bi-dribbble fs-2 me-2" }, null, -1)
const _hoisted_6 = { class: "d-flex" }
const _hoisted_7 = ["onClick"]
const _hoisted_8 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_tooltip = _resolveComponent("el-tooltip")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_el_pagination = _resolveComponent("el-pagination")!
  const _component_el_empty = _resolveComponent("el-empty")!
  const _component_AddEdit = _resolveComponent("AddEdit")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_component_el_select, {
          modelValue: _ctx.searchType,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.searchType) = $event)),
          class: "me-4",
          placeholder: "Tipo",
          size: "large",
          clearable: "",
          onChange: _ctx.getData
        }, {
          default: _withCtx(() => [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.setting.types, (item) => {
              return (_openBlock(), _createBlock(_component_el_option, {
                key: item.iddetails,
                label: item.name,
                value: item.iddetails
              }, null, 8, ["label", "value"]))
            }), 128))
          ]),
          _: 1
        }, 8, ["modelValue", "onChange"]),
        _createVNode(_component_el_input, {
          modelValue: _ctx.searchText,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.searchText) = $event)),
          class: "w-250px me-4",
          size: "large",
          placeholder: "Buscar...",
          clearable: "",
          onKeypress: _withKeys(_ctx.getData, ["enter"]),
          onClear: _ctx.getData
        }, {
          append: _withCtx(() => [
            _createVNode(_component_el_button, {
              type: "primary",
              onClick: _ctx.getData
            }, {
              default: _withCtx(() => [
                _hoisted_3
              ]),
              _: 1
            }, 8, ["onClick"])
          ]),
          _: 1
        }, 8, ["modelValue", "onKeypress", "onClear"])
      ]),
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("button", {
          type: "button",
          class: "btn btn-sm btn-primary",
          onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.onRegister && _ctx.onRegister(...args)))
        }, [
          _hoisted_5,
          _createTextVNode("Registrar ")
        ])
      ])
    ]),
    (_ctx.listSports.length>0)
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
          _withDirectives((_openBlock(), _createBlock(_component_el_table, {
            data: _ctx.listSports,
            border: "",
            "table-layout": 'auto'
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_table_column, {
                prop: "idsport",
                label: "ID",
                width: "80",
                align: "center"
              }),
              _createVNode(_component_el_table_column, {
                prop: "acronym",
                label: "Abrev"
              }),
              _createVNode(_component_el_table_column, {
                prop: "name",
                label: "Deporte"
              }),
              _createVNode(_component_el_table_column, {
                prop: "slug",
                label: "Slug"
              }),
              _createVNode(_component_el_table_column, {
                prop: "categorie_name",
                label: "Tipo"
              }),
              _createVNode(_component_el_table_column, {
                label: "Estado",
                width: "120",
                align: "center"
              }, {
                default: _withCtx((scope) => [
                  _createElementVNode("span", {
                    class: _normalizeClass('badge badge-' + scope.row.status_class)
                  }, _toDisplayString(scope.row.status_name), 3)
                ]),
                _: 1
              }),
              _createVNode(_component_el_table_column, {
                width: "100",
                label: "OP",
                fixed: "right"
              }, {
                default: _withCtx((scope) => [
                  _createElementVNode("div", _hoisted_6, [
                    _createVNode(_component_el_tooltip, {
                      effect: "dark",
                      content: "Editar",
                      placement: "top"
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("i", {
                          class: "bi bi-pencil-square fs-2 text-hover-primary me-4",
                          onClick: ($event: any) => (_ctx.onEdit(scope.row))
                        }, null, 8, _hoisted_7)
                      ]),
                      _: 2
                    }, 1024),
                    _createVNode(_component_el_tooltip, {
                      effect: "dark",
                      content: "Eliminar",
                      placement: "top"
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("i", {
                          class: "bi bi-trash fs-2 text-hover-danger me-4",
                          onClick: ($event: any) => (_ctx.onDelete(scope.row))
                        }, null, 8, _hoisted_8)
                      ]),
                      _: 2
                    }, 1024)
                  ])
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["data"])), [
            [_directive_loading, _ctx.loader]
          ]),
          _createVNode(_component_el_pagination, {
            class: "mt-4",
            "current-page": _ctx.currentPage,
            "onUpdate:currentPage": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.currentPage) = $event)),
            "page-size": _ctx.pageSize,
            "onUpdate:pageSize": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.pageSize) = $event)),
            "page-sizes": [100, 200, 300, 400],
            small: false,
            background: true,
            layout: "total, prev, pager, next",
            total: _ctx.totalItems,
            onCurrentChange: _ctx.handleCurrentChange
          }, null, 8, ["current-page", "page-size", "total", "onCurrentChange"])
        ], 64))
      : _withDirectives((_openBlock(), _createBlock(_component_el_empty, {
          key: 1,
          description: "No se encontrarón registros"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_button, {
              type: "primary",
              onClick: _ctx.getData
            }, {
              default: _withCtx(() => [
                _createTextVNode("Volver a intentar")
              ]),
              _: 1
            }, 8, ["onClick"])
          ]),
          _: 1
        })), [
          [_directive_loading, _ctx.loader]
        ]),
    _createVNode(_component_AddEdit, {
      setting: _ctx.setting,
      onOnResponse: _ctx.onResponse,
      item: _ctx.rowItem
    }, null, 8, ["setting", "onOnResponse", "item"])
  ], 64))
}